// @flow
import React, { type Node } from 'react';
import prop from 'ramda/es/prop';
import toLower from 'ramda/es/toLower';

import PlainIcon, { iconTypes } from 'app/common/ui-next/plain-icon';


const knownTypes = {
  'application/vnd.ms-excel': true,
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': true,
  'application/msword': true,
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': true,
  'application/pdf': true,
};

type Props = {
  className: string,
  type: string,
  name: string,
}

const FileIcon = ({ className, type, name }: Props): Node => {
  const fileType = knownTypes[type] ? type : toLower(prop(0, name.match(/\.[0-9a-z]+$/i)) || '');

  switch (fileType) {
    case '.xls':
    case '.xlsx':
    case 'application/vnd.ms-excel':
    case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
      return (
        <PlainIcon
          className={className}
          type={iconTypes.EXCEL32}
          width={40}
          height="auto"
        />
      );

    case '.doc':
    case '.docx':
    case 'application/msword':
    case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
      return (
        <PlainIcon
          className={className}
          type={iconTypes.WORD32}
          width={40}
          height="auto"
        />
      );

    case '.pdf':
    case 'application/pdf':
      return (
        <PlainIcon
          className={className}
          type={iconTypes.PDF32}
          width={40}
          height="auto"
        />
      );

    default:
      return (
        <PlainIcon
          className={className}
          type={iconTypes.IMG32}
          width={40}
          height="auto"
        />
      );
  }
};

export default FileIcon;
